import { datadogLogs } from '@datadog/browser-logs'

import { DatadogEnv } from '../types'
import { hasWindow } from '../utils'

export const initDataDogLogging = (
  { serviceName: service, datadogRumClientToken: clientToken }: DatadogEnv,
  env: string,
): void => {
  if (hasWindow) {
    datadogLogs.init({
      clientToken,
      site: 'datadoghq.eu',
      forwardErrorsToLogs: true,
      service,
      sessionSampleRate: 100,
      silentMultipleInit: true,
    })

    datadogLogs.setGlobalContextProperty('env', env)
  }
}
